var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        active: _vm.active,
        overlay: !_vm.assessmentLoader,
        'overlay-assessment': _vm.assessmentLoader,
    }},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-ring"},[_c('div',{staticClass:"loader-ring-light"}),_c('div',{staticClass:"loader-ring-track"})])}]

export { render, staticRenderFns }